import {STUDENT_ENDPOINTS} from '~/constants';
import {ThunkApi} from '~/utils/thunk-api';
import {DeleteParams, FetchParams, PostParams, PutParams} from '~/utils/thunk-api/type';
import {StudentEntity, NormalizedStudent, StudentUser} from '~/redux/students/types';
import {studentSchema} from '~/redux/students/entity-config';

export interface FetchStudentsParams extends FetchParams {}

export interface AddStudentRegisterParams extends PostParams {
  data: {
    user: StudentUser;
  };
}

export interface UpdateStudentParams extends PutParams {
  data: Partial<StudentEntity>;
  id: number;
}

const thunk = new ThunkApi<StudentEntity, NormalizedStudent>('student', studentSchema);
export const fetchStudents = thunk.fetch<FetchStudentsParams>(STUDENT_ENDPOINTS.STUDENT_REGISTERS);
export const addStudentRegister = thunk.post<AddStudentRegisterParams>(
  STUDENT_ENDPOINTS.STUDENT_REGISTERS,
  'addRegister',
  {
    isSnakeCase: false,
  },
);

export const addStudentAmbassadorRegister = thunk.post<AddStudentRegisterParams>(
  STUDENT_ENDPOINTS.AMBASSADOR_REGISTER,
  'addAmbassadorRegister',
  {
    isSnakeCase: false,
    includeApiResponseData: true,
    withoutNormalize: true,
  },
);
// export const updateStudent = thunk.put<UpdateStudentParams>(`${STUDENT_ENDPOINTS.STUDENT_REGISTERS}/:id`);
// export const deleteStudent = thunk.delete<DeleteParams>(`${STUDENT_ENDPOINTS.STUDENT_REGISTERS}/:id`);
